import DeletableButton from './DeletableButton';

export default DeletableButton;
